import { graphql } from "gatsby";
import React, { useState } from "react";

import PropTypes from "prop-types";
import { Box } from "theme-ui";
import { Modal } from "ui";
import { Helmet } from "react-helmet";
import { Splide, SplideSlide } from "@splidejs/react-splide";

import FloatingWhatsappBtn from "modules/home/components/FloatingWhatsappBtn";
import ContactForm from "../component-v2/ContactForm";
import { AmbassadorContactForm } from "../component-v2/AmbassadorContactForm";

import Layout from "../layout/default/Layout";
import Timeline from "../dynamic/components/Timeline";
import steps from "../modules/from-abroad/data/steps.js";
import contactInfo from "../modules/from-abroad/data/contact-us.js";

import fromAbroadOneImg from "../images/from-abroad-one.jpg";
import fromAbroadTwoImg from "../images/from-abroad-two.jpg";
import fromAbroadOneMobileImg from "../images/m-from-abroad-one.jpg";
import fromAbroadTwoMobileImg from "../images/m-from-abroad-two.jpg";

import advisorOneUrl from "../images/asesor-one.png";
import advisorTwoUrl from "../images/asesor-two.png";

import fromAbroadBanner from "../images/from-abroad-banner.jpg";
import fromAbroadMobileBanner from "../images/from-abroad-m-banner.jpg";
import { Icon } from "components";
import NewProjectsSlider from "dynamic/components/NewProjectsSlider";

function FromAbroadPage({ data, ...props }) {
  const [openModal, setOpenModal] = useState(false);
  const handler = () => setOpenModal(true);

  const members = [
    {
      photo: {
        url: advisorOneUrl,
        alt: "Diana",
      },
      name: "DIANA LUCÍA OCAMPO R.",
      position: "Coordinadora Comercial",
    },
    {
      photo: {
        url: advisorTwoUrl,
        alt: "William",
      },
      name: "WILLIAM DAVID MARIN C.",
      position: "Consultor Comercial",
    },
  ];

  const images = [
    {
      onClick: () => {},
      url: fromAbroadOneImg,
      mobileUrl: fromAbroadOneMobileImg,
    },
    {
      onClick: () => {
        setOpenModal(true);
      },
      url: fromAbroadTwoImg,
      mobileUrl: fromAbroadTwoMobileImg,
    },
  ];

  return (
    <Layout
      headerAds={data?.drupal?.ads?.header}
      popupAds={data?.drupal?.ads?.popUp}
      footerAds={data?.drupal?.ads?.footer}
    >
      <Helmet>
        <title>Compras desde el exterior | Coninsa</title>
        <meta
          name="description"
          content="Déjanos ayudarte a alcanzar tus metas y ser partícipes de la alegría de comprar un inmueble en Colombia para vivir o invertir"
        />
        <link
          rel="canonical"
          href="https://www.coninsa.co/desde-el-exterior/"
        />
      </Helmet>
      <h1 hidden>¿Estas en el exterior?</h1>
      <Box sx={{ display: ["none", "block"] }}>
        <FloatingWhatsappBtn path="https://api.whatsapp.com/send?phone=573123636333&text=Hola!" />
      </Box>

      <div {...props}>
        <Splide
          options={{
            arrows: true,
            type: "fade",
            autoplay: true,
            rewind: true,
            perPage: 1,
            interval: 5000,
            pagination: true,
          }}
        >
          {images.map((image, index) => (
            <SplideSlide key={index}>
              <picture onClick={image.onClick}>
                <source
                  media="(max-width: 640px)"
                  srcSet={`${image.mobileUrl} 640w`}
                  sizes="640px"
                />
                <source srcSet={`${image.url} 1280w`} sizes="1280px" />
                <img src={image.url} />
              </picture>
            </SplideSlide>
          ))}
        </Splide>

        <div className="relative md:flex md:justify-center bg-coninsa-gray-300 py-12 mx-5">
          <div>
            <h2
              className="bg-coninsa-blue-900 font-display font-extralight leading-8 md:leading-9 px-10 md:px-8 py-5 md:py-6
                rounded-lg shadow-[0px_3px_6px_#00000029] text-[28px] md:text-4xl text-white uppercase text-center relative"
            >
              <span className="font-semibold">¡Estás a pocos pasos</span> de
              lograr tu sueño!
            </h2>
            <span
              className="absolute w-0 h-0 border-t-[25px] border-t-transparent border-r-[22px] md:border-r-[32px]
                border-r-transparent border-l-transparent border-b-[22px] md:border-b-[32px]
                border-b-coninsa-blue-900 border translate-x-52 md:translate-x-44 rotate-180"
            ></span>
          </div>
        </div>

        <div className="bg-coninsa-gray-300 pb-10 pt-12 md:pt-24 md:pb-10">
          <div className="container mb-8 md:mb-14">
            <div className="block px-5 md:px-0 text-sm md:grid grid-cols-3 gap-x-4 gap-y-24 md:text-base">
              {steps?.map((step) => (
                <div
                  className="rounded-lg bg-coninsa-white-300 border border-solid border-transparentpx-4 mb-[70px]
                    last:mb-0 md:mb-0 px-4 md:px-5 pb-4 md:pb-5 shadow-[0px_3px_6px_#00000029] opacity-100"
                >
                  <div className="mb-4 md:mb-7 md:ml-4 border relative -translate-y-5">
                    <img
                      src={step?.icon}
                      className="absolute w-[85px] h-[85px] md:w-[110px] md:h-[110px] block -left-1 md:-left-4 -top-8 md:-top-10 z-10"
                    />
                    <h4 className="bg-coninsa-green-400 text-white px-5 py-[6px] font-bold rounded-[4px] uppercase text-end">
                      {step?.step}
                    </h4>
                    <span
                      className="absolute w-0 h-0 border-t-[20px] border-t-transparent border-r-[22px]
                      border-r-transparent border-l-transparent border-b-[20px]border-b-cobg-coninsa-green-400
                      border rotate-180 right-8 md:right-9 top-8 md:top-9"
                    ></span>
                  </div>

                  <h5 className="font-bold text-coninsa-blue-900 text-base md:text-[17px]">
                    {step?.title}
                  </h5>
                  <p className="text-coninsa-gray-900 leading-5">
                    {step?.body}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="container py-5 lg:py-8 md:pt-16 md:pb-0">
            <a onClick={handler} className="cursor-pointer">
              <img className="hidden lg:block" src={fromAbroadBanner} />
              <img className="block lg:hidden" src={fromAbroadMobileBanner} />
            </a>
          </div>
        </div>

        <div className="container px-5 py-8 md:pt-12 md:pb-12 md:px-0">
          <h3 class="text-2xl md:text-[33px] text-coninsa-blue-900 font-display font-normal mb-2">
            Conoce nuestra oferta de proyectos
          </h3>

          <p className="max-w-4xl mb-4">
            Te presentamos algunos de nuestros proyectos nuevos para comprar.{" "}
            <br />
            Allí encontrarás toda nuestra oferta de proyectos nuevos de
            vivienda, comercio, industria y servicios.
          </p>

          <NewProjectsSlider />
        </div>

        <div className="container px-5 md:px-0">
          <div className="flex gap-4 overflow-x-auto md:overflow-x-hidden pb-4">
            <div
              className="w-[87%] md:w-[calc(50%-.5rem)] flex-shrink-0 bg-coninsa-blue-900 grid grid-cols-1
                lg:grid-cols-[51%_49%] gap-2 items-center p-4 md:px-6 md:py-9 rounded-lg opacity-100"
            >
              <p className="text-white">
                Si compraste un inmueble de comercio o vivienda por inversión,
                <span className="font-bold">
                  {" "}
                  en Coninsa te lo rentabilizamos
                </span>
                .
              </p>
              <div>
                <a
                  href="https://contenidos.coninsa.co/preconsignar-inmueble"
                  target="_blank"
                  className="text-white border border-white inline-block rounded-md text-sm font-bold px-5 py-[10px]
                    cursor-pointer uppercase hover:bg-white hover:text-coninsa-green-300"
                >
                  Preconsigna tu inmueble
                </a>
              </div>
            </div>

            <div
              className="w-[87%] md:w-[calc(50%-.5rem)] flex-shrink-0 bg-coninsa-blue-900 grid grid-cols-1
                lg:grid-cols-[52%_48%] gap-4 items-center p-5 md:px-6 md:py-9 rounded-lg opacity-100"
            >
              <p className="text-white mb-2 md:mb-0">
                Si deseas arrendar o comprar apartamento usado, locales, bodegas
                u oficinas,{" "}
                <span className="font-bold">
                  tenemos variedad de opciones para ti
                </span>
                .
              </p>

              <div>
                <a
                  href="https://busquedas.coninsa.co/inmuebles/arriendo"
                  target="_blank"
                  className="text-white border border-white inline-block rounded-md text-sm font-bold px-5 py-[10px]
                  cursor-pointer uppercase hover:bg-white hover:text-coninsa-green-300"
                >
                  Conoce nuestra oferta
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="container md:pb-14 md:pt-16 flex flex-col items-center">
          {/* Título centrado arriba del video */}
          <Box
            sx={{
              color: "neutral",
              fontFamily: "heading",
              fontSize: ["26px", "33px"],
              mb: "small",
              opacity: 1,
              textAlign: "center",
            }}
          >
            Testimonios{" "}
            <Box
              as="span"
              sx={{ fontSize: ["28px", "36px"], fontWeight: "semibold" }}
            >
              Clientes contentos con el proceso de compra en el exterior.
            </Box>
          </Box>

          {/* Video centrado */}
          <div className="md:w-[600px] border-t-10 border-b-10 border-transparent mx-auto">
            <iframe
              width="600"
              height="315"
              src="https://www.youtube.com/embed/mAVo1cRzuy4?si=1xT4gps1xMNQ-sr1"
              title="Coninsa - Colext"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
              className="w-full"
            ></iframe>
          </div>
        </div>

        <div className="bg-coninsa-gray-300 pb-5 pt-7 md:pb-14 md:pt-16 overflow-x-auto px-5 md:px-0">
          <div className="container">
            <div className="mb-5 md:mb-12">
              <Box
                sx={{
                  color: "neutral",
                  fontFamily: "heading",
                  fontSize: ["26px", "33px"],
                  mb: "small",
                  opacity: 1,
                  textAlign: "center",
                }}
              >
                Tenemos un equipo dispuesto{" "}
                <Box
                  as="span"
                  sx={{ fontFamily: ["28px", "36px"], fontWeight: "semibold" }}
                >
                  PARA RESOLVER TUS DUDAS
                </Box>
              </Box>
              <Box
                sx={{
                  borderBottom: "2px solid",
                  borderColor: "secondary",
                  width: "303px",
                  m: "0 auto",
                }}
              />
            </div>

            <div className="flex gap-4 md:gap-8 md:justify-center pb-4 md:pb-0">
              {members?.map((member) => (
                <div className="flex-shrink-0 md:flex-shrink">
                  <img
                    className="h-56 w-52 md:h-auto md:w-auto"
                    src={member?.photo?.url}
                  />

                  <div class="text-center text-coninsa-gray-900">
                    <div className="font-display text-xl font-medium opacity-100 md:text-2xl">
                      {member?.name}
                    </div>
                    <div className="text-xs md:text-sm">{member?.position}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-coninsa-green-300 pb-10 pt-10 md:pt-16 md:pb-16">
          <div className="container px-5 md:px-0 text-center mb-8">
            <h3 className="font-display text-white text-[28px] md:text-[33px]">
              Puedes <span className="font-medium">comunicarte</span> con
              nosotros
            </h3>
            <p className="text-white text-base md:text-lg mb-4">
              y así recibirás un acompañamiento más personalizado
            </p>
            <div className="border border-solid border-white w-[302px] my-0 mx-auto"></div>
          </div>

          <div className="container">
            <div className="flex flex-col px-14 md:px-0 md:flex-row gap-4 justify-center mb-4 md:mb-0 ">
              {contactInfo?.map((item) => (
                <a
                  href={item?.path}
                  target="_blank"
                  className="bg-coninsa-green-500 flex rounded-lg px-5 py-[14px] min-w-[258px]
                    text-white hover:bg-white hover:text-coninsa-green-500 cursor-pointer"
                >
                  <outline-icon
                    class="w-[30px] h-[32px] block"
                    src={item?.icon}
                  />
                  <p className="ml-6 leading-4">
                    {item?.tag} <br />
                    <span className="font-extrabold uppercase">
                      {item?.label}
                    </span>
                  </p>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-white relative pb-10 md:pb-16">
          <div className="absolute bg-coninsa-green-300 h-48 left-0 right-0 top-0"></div>
          <div className="container relative">
            <div className="px-5 md:px-40">
              <div className=" bg-white rounded-lg opacity-100 p-6 md:p-10 shadow-[0px_3px_6px_#00000029]">
                <p className="text-base md:text-lg text-center mb-4 font-medium">
                  O déjanos tus datos y te devolvemos una llamada
                </p>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-coninsa-blue-900 py-10 md:py-16">
          <div className="container px-5 md:px-0 text-white">
            <h3 className="font-display font-extralight mb-0 text-[28px] md:text-[33px]">
              ¿Por qué confiar en <span className="font-medium">Coninsa</span>?
            </h3>
            <Timeline />
          </div>
        </div>

        <div className="co-section bg-s2-mint py-6 text-white">
          <div className="container text-center">
            <a
              className="co-link text-sm font-bold md:text-xl"
              href="https://d2xt7650da4t25.cloudfront.net/s3fs-public/2025-04/TE%CC%81RMINOS%20Y%20CONDICIONES%20Ebajadores%20Coninsa.pdf?VersionId=WBILAx8ViXw4ljTjj_TOpXERQi_pcYND"
              target="_blank"
            >
              * Conoce los términos y condiciones de esta promoción
            </a>
          </div>
        </div>

        <Modal
          sx={{ width: ["100%", "95vw", null, "1124px"] }}
          open={openModal}
          variant="fullDark"
        >
          <Modal.Content variant="fullDark">
            <div className="bg-s2-gray-100 p-6 lg:px-16 lg:py-8 relative">
              <button
                className="absolute right-3 top-3"
                onClick={() => setOpenModal(false)}
              >
                <Icon name="close" className="text-blue-900" />
              </button>
              <div className="mb-4">
                <h4 className="uppercase bg-s2-teal text-xl lg:text-3xl font-display font-medium text-white text-center py-3 px-4 lg:px-8 rounded-xl mb-3 lg:mb-4">
                  Conviértete en embajador coninsa y gana por conectar
                  inversionistas con colombia
                </h4>
                <p className="text-center text-base lg:text-lg mb-4 lg:mb-10">
                  Únete a nuestra red global de aliados y gana por recomendar
                  nuestros proyectos de vivienda a personas que vivan fuera del
                  país y estén interesadas en invertir en Colombia, sean
                  colombianos en el exterior o extranjeros.
                </p>
              </div>

              <div className="bg-s2-white p-4 lg:py-6 px-6 lg:px-10 rounded-lg shadow-[0px_3px_6px_#00000029]">
                <AmbassadorContactForm />
              </div>
            </div>
          </Modal.Content>
        </Modal>
      </div>
    </Layout>
  );
}

FromAbroadPage.propTypes = {
  data: PropTypes.oneOf({}).isRequired,
};

export default FromAbroadPage;

export const pageQuery = graphql`
  query FromAbroadPageQuery {
    drupal {
      ads: getAdsByUrl(path: "/desde-el-exterior") {
        header {
          id: nid
          image: fieldImage {
            url
          }
          url: fieldUrl {
            uri
            title
          }
        }
        popUp {
          id: nid
          image: fieldImage {
            url
          }
          url: fieldUrl {
            uri
            title
          }
        }
        footer {
          id: nid
          image: fieldImage {
            url
          }
          url: fieldUrl {
            uri
            title
          }
        }
      }
    }
  }
`;
